<template>
  <div class="content">
    <Form :model="formData" :label-width="150">
      <FormItem label="语音合成引擎">
        <Select v-model="formData.engine" style="width: 420px" :disabled="!isEdit" @on-change="engineChange">
          <Option v-for="item of ttsList" :key="item.engineName" :value="item.engineName">{{item.label || item.engineName}}</Option>
        </Select>
      </FormItem>
      <FormItem label="语音合成发音人">
        <Select
						:key="formData.engine"
						v-model="formData.speaker"
            style="width: 420px"
						filterable
						allow-create
						placeholder="请输入，按回车添加"
            :disabled="!isEdit"
            @on-create="addSpeaker"
						@on-change="speakerChange"
					>
            <Option v-for="item of (speakers || [])" :key="item.vocalName" :value="item.vocalName">{{item.label || item.vocalName}}</Option>
					</Select>
      </FormItem>
      <FormItem label="音量">
        <InputNumber :max="100" :min="0" v-model="formData.volume" :disabled="!isEdit" style="width: 200px"></InputNumber>
      </FormItem>
      <FormItem label="速度">
        <InputNumber :max="100" :min="0" v-model="formData.speed" :disabled="!isEdit" style="width: 200px"></InputNumber>
      </FormItem>
      <FormItem label="语调">
        <InputNumber :max="100" :min="0" v-model="formData.pitch" :disabled="!isEdit" style="width: 200px"></InputNumber>
      </FormItem>
      <FormItem label="参数">
        <div class="adv-params">
          <div
            v-for="(value, index) in formData.params"
            :key="index"
            class="adv-params__row"
          >
            <Input v-model="formData.params[index].key" :disabled="!isEdit" placeholder="参数名" />
            <Input v-model="formData.params[index].val" :disabled="!isEdit" />
            <Icon
              class="var-del-icon"
              color="#ed4014"
              type="ios-trash-outline"
              @click="formData.params.splice(index, 1)"
            />
          </div>
          <Button
            class="adv-params__add"
            type="dashed"
            long
            icon="md-add"
            :disabled="!isEdit"
            @click="addParameters"
          >添加参数</Button>
        </div>
      </FormItem>
        <FormItem>
          <Button type="primary" v-show="!isEdit" @click="openEdit">编辑</Button>
          <Button type="primary" v-show="isEdit" @click="save">保存</Button>
          <Button style="margin-left: 8px" v-show="isEdit" @click="cancel">取消</Button>
        </FormItem>
    </Form>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getTtsListA } from '@/server/api'
import cloneDeep from 'lodash/cloneDeep'

export default {
  data() {
    return {
      isEdit: false,
      formData: {
        engine: 'aliyun',                 //TTS 引擎  目前支持 aliyun（阿里云在线合成） xufei（讯飞离线合成）
        speaker: 'aixia',                 //TTS 发音人 通过接口获取列表
        volume: 50,                       //音量 0-100
        speed: 50,                         //速度 0-100
        pitch: 50,                         //语调 0-100
        params: [],
      },
      allTtsList: [],
      addSpeakers: [],
    }
  },
	computed: {
    ...mapState('setting', ['tts']),
    ...mapState('user', ['access']),
    ttsList() {
      return this.allTtsList.filter(item =>
        ['sambert', 'aliyun'].includes(item.engineName) || this.access.flowLlm
      )
    },
    ttsMap() {
      return this.ttsList.reduce((map, item) => {
        map[item.engineName] = item.ttsVocal || []
        return map
      }, {})
    },
    speakers() {
      return [...(this.ttsMap[this.formData.engine] || []), ...this.addSpeakers]
    },
	},
  watch: {
    tts: {
      immediate: true,
      handler(val) {
        this.resetForm()
        // 如果 speaker 不在 speakers 列表中，则添加到 speakers 列表中
        if (!this.speakers.find(item => item.vocalName === val.speaker)) {
          this.addSpeaker(val.speaker)
        }
      }
    },
    speakers: {
      immediate: true,
      handler(val) {
        const engines = this.ttsMap[this.formData.engine] || []
        for (let i = 0; i < engines.length; i++) {
          const index = this.addSpeakers.map(item => item.vocalName).indexOf(engines[i].vocalName)
          if (index > -1) {
            this.addSpeakers.splice(index, 1)
          }
        }
      }
    }
  },
  created() {
    this.getTtsList();
  },
  methods: {
    ...mapActions('setting', ['updateTts']),
    openEdit() {
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.resetForm();
    },
    resetForm() {
      const tts = cloneDeep(this.tts) || {}
      const paramsSource =
        tts.params && typeof tts.params === 'object'
          ? tts.params
          : tts.adv_params && typeof tts.adv_params === 'object'
            ? tts.adv_params
            : {}
      let params = []
      if (Array.isArray(paramsSource)) {
        params = paramsSource
          .map((item) => {
            if (!item || typeof item !== 'object') return null
            const key = String(item.key != null ? item.key : '').trim()
            if (!key) return null
            const val = item.val != null ? item.val : item.value
            return {
              key,
              type: item.type || (typeof val === 'string' ? 'STR' : 'NUM'),
              val,
            }
          })
          .filter(Boolean)
      } else {
        params = Object.keys(paramsSource).map((key) => ({
          key,
          type: typeof paramsSource[key] === 'string' ? 'STR' : 'NUM',
          val: paramsSource[key],
        }))
      }
      this.formData = {
        ...this.formData,
        ...tts,
        speaker: this.normalizeSpeaker(tts.speaker != null ? tts.speaker : this.formData.speaker),
        params,
      }
    },
    save() {
      this.formData.speaker = this.normalizeSpeaker(this.formData.speaker)
      const { params, adv_params, ...formData } = this.formData
      const parameters = (params || []).filter((item) => !!item.key).reduce((item, next) => {
        if (next.type === 'NUM') {
          item[next.key] = Number(next.val)
        } else {
          item[next.key] = next.val
        }
        return item
      }, {})
      this.updateTts({
        ...formData,
        params: parameters,
      })
      this.isEdit = false
    },
    addParameters() {
      this.formData.params.push({ key: '', type: 'STR', val: '' })
    },
    // 获取tts列表
    getTtsList() {
      getTtsListA().then(res => {
        if (res.code !== 200) return;
        this.allTtsList = res.data || []
      })
    },
    addSpeaker(val) {
      const vocalName = this.normalizeSpeaker(val)
      if (!vocalName || this.speakers.some(item => item.vocalName === vocalName)) return
      this.addSpeakers.push({
        vocalName,
      })
    },
    speakerChange(val) {
      this.formData.speaker = this.normalizeSpeaker(val)
    },
    normalizeSpeaker(val) {
      return typeof val === 'string' ? val.trim() : val
    },
    engineChange() {
      this.formData.speaker = ''
      this.addSpeakers = []
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
}

.adv-params {
  width: 400px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.adv-params__row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  ::v-deep .ivu-input-wrapper {
    flex: 1;
    min-width: 0;
  }
}

.adv-params__add {
  width: 100%;
  margin-left: 0;
}

.var-del-icon {
  cursor: pointer;
  line-height: 32px;
}
</style>
